<template>
  <div class="index">
    <div class="centered city-addition">
        <draggable v-model="eventCityObject" :options="{ disabled: editableCity !== null }">
          <span v-for="place in eventCityObject" class="city-wrapper" @click="handleGetEventCity(place.id)">
            <router-link :key="place.id"
              :class="$route.params.id === place.id || !$route.params.id && eventCities[0].id === place.id? 'is-active' : '' "
              :to="{ name: 'Events', params: { id: place.id }  }"
              v-if="editableCity !== place.id"
              class="city-title">{{place.name}}
            </router-link>
            <span v-else class="edit-city-wrapper">
              <a class="delete hide-edit-city" @click="toggleEditCity(place.id)"></a>
              <b-input v-model="newCityName"
              class="edit-city-input"></b-input>
              <img src="/static/img/icons/apply.svg" class="apply-icon is-medium" @click="handleUpdateEventCities"/>
            </span>
            <img src="/static/img/icons/edit.svg" class="edit-icon" @click="toggleEditCity(place.id)"/>
          </span>
        </draggable>
        <span class="button-wrapper city-addition-wrapper" @click="toggleAddition" v-if="!cityAdditionVisible">
          <a class="button is-info">+</a> Добавить город
        </span>
        <b-field class="city-addition-input" v-if="cityAdditionVisible">
            <b-input placeholder="Введите название города" v-model="cityName"></b-input>
            <span class="city-addition-button is-primary button" @click="handleNewEventCity">Добавить</span>
            <span class="city-addition-button is-warning button" @click="toggleAddition">Отмена</span>
        </b-field>
    </div>
    <div class="events" v-if="eventCity">
      <div class="centered">
        <span class="button-wrapper" @click="handleAddEvent">
          <a class="button is-info">+</a> Добавить мероприятие
        </span>
      </div>
      <div class="events columns is-multiline" v-if="eventCity.events">
        <router-link class="event-wrapper column is-half"
        v-for="event in eventCity.events" :key="event.id"
        :to="{ name: 'Event', params: { id: event.id }  }"  >
          <div class="event centered">
            <span class="link" @click="showParticipants" :id='event.id' ref="event.id" v-if="event.eventParticipants.length">
              Посмотреть {{ event.eventParticipants.length }} зарегистровавшихся
            </span>
            <span>{{event.date | filterDate}} <br></span>
            <span class="event-title">{{event.title}} <br></span>
            <span>{{event.description}} <br></span>
          </div>
        </router-link>
      </div>
      <div class="columns">
        <div class="column delete-service" @click="deleteEventCity(eventCity.id)">
          <span>Удалить город и все мероприятия</span>
        </div>
      </div>
    </div>
    <el-dialog v-if="event" class="event-dialog"
      :visible.sync="dialogVisible"
      >
      <div class="event-participants">
        <span>
          {{ event.title }}
        </span>
        <span>
          {{ event.date }}
        </span>
        <span class="event-participants-count">
          {{event.eventParticipants.length}}
        </span>
        <table class="participants-table">
          <tr v-for="participant in event.eventParticipants">
            <td class="name"> {{ participant.surname }} <br> {{ participant.name }} {{ participant.patronymic}}</td>
            <td class="commpany-name"> {{ participant.companyName }}</td>
            <td> {{ participant.phone }}</td>
            <td> {{ participant.email }}</td>
          </tr>
        </table>
      </div>
    </el-dialog>
  </div>
</template>


<script>
import { mapState, mapActions } from 'vuex'
import moment from 'moment'
import deepcopy from 'deepcopy'
import draggable from 'vuedraggable'
import uuidv4 from 'uuid/v4'

export default {
  name: 'Events',
  data () {
    return {
      cityName: '',
      newCityName: '',
      cityAdditionVisible: false,
      dialogVisible: false,
      editableCity: null,
      event: null
    }
  },
  computed: {
    ...mapState(['eventCities', 'eventCity']),
    eventCityObject: {
      get () {
        return deepcopy(this.eventCities)
      },
      set (val) {
        for (let i = 0; i < val.length; i++) {
          val[i].order = i
        }
        this.updateEventCities(val)
      }
    }
  },
  created () {
    this.getEventsPlaces(this.$route.params.id)
  },
  filters: {
    filterDate (date) {
      if (date) {
        const d = new Date(date)
        return `${d.getFullYear()}/${d.getMonth() + 1}/${d.getDate()}`
      }
    }
  },
  methods: {
    ...mapActions(['getEventsPlaces', 'addEventCity', 'getEventCity', 'deleteEventCity',
      'addNewEvent', 'updateEventCities']),
    toggleAddition () {
      this.cityAdditionVisible = !this.cityAdditionVisible
    },
    handleNewEventCity () {
      this.addEventCity(this.cityName)
      this.cityName = ''
      this.toggleAddition()
    },
    handleGetEventCity (id) {
      this.getEventCity(id)
    },
    showParticipants (ev) {
      const id = ev.target.id
      this.event = deepcopy(this.eventCity.events.find(e => e.id === id))
      this.event.date = this.event.date ? moment(this.event.date).format('LLL') : ''
      this.dialogVisible = true
      ev.preventDefault()
    },
    toggleEditCity (id) {
      if (id === this.editableCity) {
        id = null
        this.newCityName = ''
      } else {
        const eventCity = this.eventCityObject.find(a => a.id === id)
        this.newCityName = eventCity.name
      }
      this.editableCity = id
    },
    handleUpdateEventCities () {
      const eventCity = this.eventCityObject.find(a => a.id === this.editableCity)
      this.editableCity = null
      eventCity.name = this.newCityName
      this.newCityName = ''
      this.updateEventCities(this.eventCityObject)
    },
    handleAddEvent () {
      const data = {
        'id': uuidv4(),
        'title': null,
        'address': null,
        'description': null,
        'photo': null,
        'newInformation': null,
        'registrationEndDate': null,
        'toWhom': null,
        'reason': null,
        'date': null,
        'location': null,
        'publishLater': false,
        'publishDate': null,
        'showSummary': false,
        'photos': [],
        'summary': null,
        'email': null,
        'event_city_id': this.eventCity.id,
        'eventCity': this.eventCity,
        'eventItems': [],
        'services': [],
        'isNew': true
      }
      this.addNewEvent(data)
    }
  },
  components: { draggable }
}
</script>

<style scoped>
@import '../../global.css';
.event {
  background: #eee;
  padding: 100px;
  color: black;
  flex-direction: column;
}
.event span {
  margin: 3px 0;
}
.event-title {
  font-weight: bold;
  font-size: 16px;
}
.event-participants > span {
  display: block;
  text-align: center;
}
.event-participants-count {
  font-weight: bold;
  margin: 5px 0;
  font-size: 1.4em;
}
.participants-table tr {
  border: 1px solid lightgray;
  border-radius: 5px;
  margin: 10px 0;
  display: block;
}
.participants-table td {
  padding: 8px 14px;
}
.participants-table .commpany-name {
  min-width: 180px;
}
.participants-table .name {
  min-width: 155px;
  font-weight: bold;
}
</style>
<style>
.event-dialog .el-dialog {
  min-width: 720px;
}
</style>



// WEBPACK FOOTER //
// EventsList.vue?1e379a70